// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"5a8bf663","739":"d56a4549"}[chunkId] + ".chunk.js";
};